/*
 *  Copyright (c) Michael Kolesidis <michael.kolesidis@gmail.com>
 *  GNU Affero General Public License v3.0
 *
 *  ATTENTION! FREE SOFTWARE
 *  This website is free software (free as in freedom).
 *  If you use any part of this code, you must make your entire project's source code
 *  publicly available under the same license. This applies whether you modify the code
 *  or use it as it is in your own project. This ensures that all modifications and
 *  derivative works remain free software, so that everyone can benefit.
 *  If you are not willing to comply with these terms, you must refrain from using any part of this code.
 *
 *  For full license terms and conditions, you can read the AGPL-3.0 here:
 *  https://www.gnu.org/licenses/agpl-3.0.html
 */

// Intro Section
export const textsInto: string[] = [
  `Abolishing the static web through fluid motion and interactive storytelling.`,
  `Bridging the gap between art direction and technical execution, I craft bespoke digital experiences for a global clientele. By operating on a limited commission basis, I ensure every project receives uncompromising focus.`,
  `When programmers try to find bugs, it helps to explain their code line-by-line to an inanimate object. This is known as rubber duck debugging.`,
];

// Contact section
export const textsContact: string[] = [
  `Like what you see? I'm always open to take on new and exciting projects — let's discuss yours!`,
  `If you have any questions, drop me a line at:<br>${(t=>t.replace(/[A-Za-z]/g,c=>String.fromCharCode((c<'a'?65:97)+(c.charCodeAt(0)-(c<'a'?65:97)+13)%26)))("zvpunry.xbyrfqvf@tznvy.pbz")}`,
];

// About section
export const textsAbout: string[] = [
  `A multidisciplinary polymath, I operate at the intersection of visual identity, digital architecture, and motion. From high-fidelity branding to experimental game mechanics, my work dissolves the boundaries between graphic design and technical execution.`,

  `I am dedicated to crafting digital permanence. By engineering immersive environments that transcend the static screen, I aim to redefine the standards of interactivity and help shape the next era of the web.`,

  `My technical arsenal is built for performance and fluidity. I leverage React, Next.js, and TypeScript as a foundation, utilizing GSAP, Three.js (R3F), and Pixi.js to breathe life into the browser.`,

  `My creative process is holistic, spanning the entire Adobe Creative Suite, DaVinci Resolve, and Ableton Live. Whether I am sculpting a layout in Figma or scoring a soundscape, I ensure every sensory detail is intentional.`,

  `I am a staunch advocate for the Open-Source Ethos. Beyond the industry-standard suites, I integrate Blender, Inkscape, and Krita into my workflow—supporting the growth of a transparent, accessible creative future.`,

  `Precision over vanity. My philosophy is simple: select the optimal tool for the objective and eliminate complexity where it doesn't serve the user.`,

  `My workspace is overseen by a dual-guard: a classic Rubber Duck for logic-clearing and a Maneki-neko for fortune. They serve as a constant reminder that the best work is born from a balance of rigor and play.`,

  `My code is fueled by pure focus, not caffeine. I operate without the crutch of coffee, save for the occasional, strictly ceremonial, cup of tea.`,
];

// This Website section
export const textsThisWebsite: string[] = [
  `A reclamation of digital play. Somewhere along the way, the web became too serious. This space is a tribute to the era of naïve web art, a love letter to the romantic amateurs and the beautiful, unpolished chaos of the GeoCities era.`,
  `I first discovered the magical world of the World Wide Web in the ’90s, and this project is my attempt to bottle some of that pixelated magic. Its visual language borrows from street art, print-era layout experimentation, and the punchy, graphic attitude of ’90s MTV.`,

  `I define the resulting aesthetic as <i>Frivobrutalism</i>: a defiant clash of whimsy and rawness. It is a space where playful, kinetic visuals meet the structural honesty and unapologetic geometry of brutalist design.`,

  `This website is free software (free as in freedom). The source code is released under the GNU Affero General Public License v3.0, and you can only use it in accordance with the license's terms and conditions.`,

  ` <span class="highlight">If you use any part of its code, you  must make your entire project's source code publicly available under the same license. This applies whether you modify the code or use it as it is in your own project.</span> `,

  `This ensures that all modifications and derivative works remain free software, so that everyone can benefit. If you are not willing to comply with these terms, you must refrain from using any part of this code.`,
];
